import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseFieldComponent } from '../base-field.component';

/**
 * Campo de tipo "image" — imagen decorativa sin control de formulario.
 * El contenido y el estilo se leen de field.customProps:
 *   src    → URL completa de la imagen en S3
 *   width  → porcentaje del contenedor (25 | 50 | 75 | 100, default 100)
 *   align  → 'left' | 'center' | 'right' (default 'center')
 */
@Component({
  selector: 'app-image-field',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="af-image-block" [ngStyle]="wrapperStyles">
      <img
        *ngIf="src"
        [src]="src"
        [style.width]="widthCss"
        class="af-image-block__img"
        alt="" />
      <div *ngIf="!src" class="af-image-block__placeholder">
        <span class="material-icons">image</span>
        <span>Imagen decorativa</span>
      </div>
    </div>
  `,
  styles: [`
    .af-image-block {
      width: 100%;
      box-sizing: border-box;
      padding: 4px 0;
    }

    .af-image-block__img {
      display: inline-block;
      max-width: 100%;
      height: auto;
    }

    .af-image-block__placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 24px;
      background: #f1f5f9;
      border: 2px dashed #cbd5e1;
      border-radius: 6px;
      color: #94a3b8;
      font-size: 12px;

      span.material-icons {
        font-size: 36px;
        width: 36px;
        height: 36px;
      }
    }
  `],
})
export class ImageFieldComponent extends BaseFieldComponent {

  get p(): Record<string, unknown> {
    return (this.field?.customProps as Record<string, unknown>) ?? {};
  }

  get src(): string {
    return String(this.p['src'] ?? '');
  }

  get widthCss(): string {
    return `${this.p['width'] ?? 100}%`;
  }

  get wrapperStyles(): Record<string, string> {
    return { textAlign: String(this.p['align'] ?? 'center') };
  }
}
